import { Breadcrumbs, Table, Field, LabelBar, ModalPanel } from "components";
import { Button, Col, Modal, Row } from "react-bootstrap";
import React, { Component } from "react";
import dayjs from "dayjs";
import { GET, POST } from "api";
import Spinner from "react-bootstrap/Spinner";

export default class RevenueReport extends Component {
     constructor(props) {
          super(props);
          this.state = {
               showModal: false,
               searchReport: { branch: [] },
               error_data: "",
               loading: false,
          };
     }

     componentDidMount = async () => {
          let branch = await GET("/ps/get_branchs");
          this.setState({ branch, searchReport: { branch: branch.map((el) => el.branch_id) } });
     };

     modalViewReport = () => {
          let { searchReport, branch } = this.state;
          return (
               <div>
                    <Row>
                         <Field
                              name={"date_start"}
                              type={"date"}
                              placeholder={searchReport.date_start ? searchReport.date_start : "วว/ดด/ปป"}
                              title={"ประจำวันที่"}
                              md={6}
                              handleSelectDate={(date, dateString, name) => this.handleSelectDate(date, dateString, name)}
                         />
                         <Field
                              name={"date_end"}
                              type={"date"}
                              placeholder={searchReport.date_end ? searchReport.date_end : "วว/ดด/ปป"}
                              title={"ถึงวันที่"}
                              md={6}
                              handleSelectDate={(date, dateString, name) => this.handleSelectDate(date, dateString, name)}
                         />
                    </Row>
                    {/* <LabelBar
                         name={"branch_name"}
                         type={"radio"}
                         title={"สาขา"}
                         label={branch?.map((el) => el.branch_name)}
                         value={searchReport?.branch_name}
                         handleChangeText={this.onChangeCheckbox}
                    /> */}
                    <LabelBar
                         type={"checkbox"}
                         title={"สาขา"}
                         md={12}
                         name={"branch"}
                         label={branch?.map((el) => ({ value: el.branch_id, name: el.branch_name }))}
                         // value={pay?.branch}
                         arrChecked={searchReport?.branch}
                         handleChangeText={this.onChangeCheckbox}
                    />
                    <Row className="button-group __submit">
                         <Col lg={6}>
                              {this.state.loading ? (
                                   <Button variant="outline-primary" disabled style={{ backgroundColor: "#fff" }}>
                                        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                        Loading...
                                   </Button>
                              ) : (
                                   <Button onClick={this.handelClickViewReport}>แสดงรายงาน</Button>
                              )}
                         </Col>
                    </Row>
               </div>
          );
     };

     modalShow = (value, rowIndex) => {
          let { showModal } = this.state;
          this.setState({ showModal: !showModal, report_title: value, row_index: rowIndex + 1 });
     };

     /*--------------------Formatter--------------------*/
     noFormatter = (cell, row, rowIndex, formatExtraData) => {
          return <div style={{ textAlign: "center" }}>{`${rowIndex + 1}`}</div>;
     };
     detailFormatter = (cell, row, rowIndex, formatExtraData) => {
          return <a onClick={() => this.modalShow(`${row.report}`, rowIndex)}>ทำรายการ</a>;
     };

     /*--------------------Handle--------------------*/
     /*--------------------Handle--------------------*/
     handleSelectDate = (date, dateString, name) => {
          let { searchReport } = this.state;
          searchReport[name] = dateString;
          this.setState({ searchReport });
     };

     onChangeCheckbox = ({ target: { name, value, checked } }) => {
          let { searchReport } = this.state;
          if (checked) {
               searchReport[name].push(Number(value));
               searchReport[name] = searchReport[name].sort((a, z) => a - z);
               this.setState({ searchReport });
          } else {
               let index = searchReport[name].findIndex((el) => el === Number(value));
               searchReport[name].splice(index, 1);
               searchReport[name] = searchReport[name].sort((a, z) => a - z);
               this.setState({ searchReport });
          }
     };

     handelClickViewReport = async () => {
          this.setState({ loading: true });
          const { searchReport, row_index, report_title, branch } = this.state;
          try {
               // let type_excel = "";
               // switch (row_index) {
               //      case 1:
               //           type_excel = "รายงานกำไรขั้นต้นจากการขายรถยนต์ (no vat)";
               //           break;
               //      // case 2:
               //      //      type_excel = "รายงานขายขาดทุน";
               //      //      break;

               //      default:
               //           break;
               // }
               // // if (searchReport.branch_id && searchReport.date_start && searchReport.date_end) {
               // //      console.log("searchReport", searchReport);
               // //      alert(`success${row_index}`);
               // //      this.modalShow();
               // // }
               // window.open(await POST("/ps/report_excel_executive", { ...searchReport, type_excel }));
               // this.modalShow();

               if (searchReport.date_start && searchReport.date_end && searchReport.branch.length > 0) {
                    searchReport.type_excel = report_title;
                    let dataBranch = searchReport.branch.map((el) => ({
                         branch_name: branch.find((e) => e.branch_id == el).branch_name,
                         branch_id: branch.find((e) => e.branch_id == el).branch_id,
                    }));
                    let res = await POST("/ps/report_excel_executive", { ...searchReport, branch: dataBranch });
                    window.open(res);
                    this.setState({ error_data: "", loading: false });
               } else {
                    this.setState({ error_data: "*กรอกข้อมูลให้ครบ*", loading: false });
               }
          } catch (error) {
               // console.log("error", error);
               this.setState({ error_data: error, loading: false });
          }
     };

     handleCloseModal = () => {
          this.setState({
               showModal: false,
               // searchReport: {},
               error_data: "",
          });
     };

     render() {
          let { showModal, report_title, error_data } = this.state;
          let table = {
               column: [
                    {
                         dataField: "no",
                         text: "ลำดับ",
                         headerClasses: "header-custom __left  __no",
                         formatter: this.noFormatter,
                    },
                    {
                         dataField: "report",
                         text: "รายงาน",
                         headerClasses: "header-custom __btn-l",
                    },
                    {
                         dataField: "generate",
                         text: "ทำรายการ",
                         headerClasses: "header-custom __right __btn-ss    ",
                         formatter: this.detailFormatter,
                    },
               ],
               data: [{ report: "รายงานกำไรขั้นต้นจากการขายรถยนต์ (no vat)" }],
               keyField: "no",
          };
          return (
               <div className="panel hide-scroll">
                    <Breadcrumbs title={[{ title: "รายงานผู้บริหาร" }]} active={0} button={""} />
                    <div className="content __input-panel">
                         <div className="input-field">
                              <div className="-body">
                                   <div className="content listreport" id="table-content">
                                        <Table type={"custom"} column={table.column} data={table.data} keyField={table.keyField} />
                                   </div>
                              </div>
                         </div>
                    </div>
                    <ModalPanel
                         type="input"
                         show={showModal}
                         title={report_title}
                         onHide={this.handleCloseModal}
                         body={this.modalViewReport()}
                         // button={[{ name: "แสดงรายงาน", variant: "primary", onClick: () => this.handelClickViewReport() }]}
                         error_data={error_data}
                    />
               </div>
          );
     }
}
